"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6102],{

/***/ 53591:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ActionListItem_ActionListItem)
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(52493);
;// CONCATENATED MODULE: ./src/components/navigation/ActionListItem/ActionListItem.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ActionListItem_module = ({"button":"EIPCU4","disabled":"LXTtTh","withBorder":"FBejZ4","withBorderBottom":"X2UaWS","style-gold-50":"rjFTmT","style-black":"TlAW5d"});
;// CONCATENATED MODULE: ./src/components/navigation/ActionListItem/ActionListItem.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var styles = (/* unused pure expression or super */ null && ([
    "gold-50",
    "black"
]));
var ActionListItem = function(props) {
    var children = props.children, className = props.className, title = props.title, label = props.label, loading = props.loading, disabled = props.disabled, _props_style = props.style, style = _props_style === void 0 ? "gold-50" : _props_style, withBorder = props.withBorder, withBorderBottom = props.withBorderBottom, _props_withArrow = props.withArrow, withArrow = _props_withArrow === void 0 ? true : _props_withArrow, rest = _object_without_properties(props, [
        "children",
        "className",
        "title",
        "label",
        "loading",
        "disabled",
        "style",
        "withBorder",
        "withBorderBottom",
        "withArrow"
    ]);
    var _obj;
    var buttonClassName = (0,clsx/* default */.Z)(className, ActionListItem_module.button, "block w-full cursor-pointer py-20", ActionListItem_module["style-".concat(style)], (_obj = {}, _define_property(_obj, ActionListItem_module.disabled, disabled), _define_property(_obj, ActionListItem_module.withBorder, withBorder), _define_property(_obj, ActionListItem_module.withBorderBottom, withBorderBottom), _obj));
    var isLabelVisible = Boolean(label);
    var buttonBaseProps = _object_spread({
        className: buttonClassName,
        loading: loading,
        disabled: disabled
    }, rest);
    var textContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: "whitespace-nowrap text-left",
        message: title,
        style: "t5"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, _object_spread_props(_object_spread({}, buttonBaseProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    isLabelVisible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            textContent,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: label,
                                style: "eye3",
                                color: "gold-50",
                                tag: "sup"
                            })
                        ]
                    }) : textContent,
                    withArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        className: "ml-16 flex-none",
                        name: "other/long-arrow-right"
                    })
                ]
            }),
            children
        ]
    }));
};
/* harmony default export */ const ActionListItem_ActionListItem = (ActionListItem);


/***/ }),

/***/ 23374:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Breadcrumbs_Breadcrumbs)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__(83475);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/components/navigation/Breadcrumbs/messages.ts
/* harmony default export */ const messages = ({
    ariaLabel: {
        en: "Breadcrumb"
    }
});

;// CONCATENATED MODULE: ./src/components/navigation/Breadcrumbs/Breadcrumbs.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Breadcrumbs_module = ({"breadcrumbs":"xPnkst","link":"GaanYo","disabled":"PiudET","navItem":"SlZKNv"});
;// CONCATENATED MODULE: ./src/components/navigation/Breadcrumbs/Breadcrumbs.tsx









var Breadcrumbs = function(props) {
    var className = props.className, items = props.items;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (0,clsx/* default */.Z)(Breadcrumbs_module.breadcrumbs, className),
        "aria-label": intl.formatMessage(messages.ariaLabel),
        "data-testid": "breadcrumbs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "flex",
            children: items.map(function(param, index) {
                var title = param.title, to = param.to, onClick = param.onClick;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: Breadcrumbs_module.navItem,
                    "aria-current": to ? null : "page",
                    "data-testid": to ? "breadcrumbsItem" : "breadcrumbsCurrent",
                    children: to ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                        className: Breadcrumbs_module.link,
                        to: to,
                        onClick: onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: title
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: title
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ const Breadcrumbs_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 62446:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Dropdown_Dropdown)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(68471);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.to-string.js
var es_error_to_string = __webpack_require__(86011);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/menu/menu.js + 2 modules
var menu = __webpack_require__(61985);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/components/navigation/Dropdown/components/Item/Item.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Item_module = ({"item":"prn3VB","button":"spePly","disabled":"SPiFZG","active":"HXYsaa"});
;// CONCATENATED MODULE: ./src/components/navigation/Dropdown/components/Item/Item.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var Item = function(props) {
    var children = props.children, className = props.className, title = props.title, to = props.to, disabled = props.disabled, loading = props.loading, onClick = props.onClick;
    var itemClassName = (0,clsx/* default */.Z)("relative block", Item_module.item, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v.Item, {
        as: Href/* default */.Z,
        className: itemClassName,
        to: to,
        disabled: disabled,
        onClick: onClick,
        children: function(param) {
            var active = param.active;
            var _obj;
            var contentClassName = (0,clsx/* default */.Z)("w-full whitespace-nowrap p-16 text-left", Item_module.button, (_obj = {}, _define_property(_obj, Item_module.active, active), _define_property(_obj, Item_module.disabled, disabled || loading), _obj));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: contentClassName,
                children: [
                    Boolean(title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p4",
                        message: title
                    }),
                    children
                ]
            });
        }
    });
};
/* harmony default export */ const Item_Item = (/*#__PURE__*/react.memo(Item));

;// CONCATENATED MODULE: ./src/components/navigation/Dropdown/Dropdown.tsx
function Dropdown_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Dropdown_define_property(target, key, source[key]);
        });
    }
    return target;
}








var Dropdown = function(props) {
    var children = props.children, className = props.className, items = props.items, _props_placement = props.placement, placement = _props_placement === void 0 ? "bottomLeft" : _props_placement, buttonDataTestId = props.buttonDataTestId;
    if (!/*#__PURE__*/ react.isValidElement(children)) {
        throw new Error("Dropdown children should be a single valid element");
    }
    var rootClassName = (0,clsx/* default */.Z)("relative", className);
    var menuClassName = (0,clsx/* default */.Z)("absolute z-tooltip block rounded bg-white py-4 shadow", {
        "top-full right-0": placement === "bottomRight",
        "top-full left-0": placement === "bottomLeft"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
        as: "div",
        className: rootClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v.Button, {
                "aria-label": "Menu",
                "data-testid": buttonDataTestId,
                children: function(param) {
                    var open = param.open;
                    return /*#__PURE__*/ react.cloneElement(children, {
                        isOpen: open
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v.Items, {
                className: menuClassName,
                children: items.map(function(itemProps, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_Item, _object_spread({}, itemProps), index);
                })
            })
        ]
    });
};
/* harmony default export */ const Dropdown_Dropdown = (/*#__PURE__*/react.memo(Dropdown));


/***/ }),

/***/ 87129:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HoverablePopover_HoverablePopover)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(73598);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/popover/popover.js + 6 modules
var popover = __webpack_require__(21864);
;// CONCATENATED MODULE: ./src/components/navigation/HoverablePopover/util/index.ts

var HoverablePopoverContext = (0,react.createContext)(null);
var useHoverablePopoverContext = function() {
    return (0,react.useContext)(HoverablePopoverContext);
};

;// CONCATENATED MODULE: ./src/components/navigation/HoverablePopover/components/Button/Button.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var Button = function(props) {
    var buttonRef = useHoverablePopoverContext().buttonRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J.Button, _object_spread_props(_object_spread({}, props), {
        ref: buttonRef
    }));
};
Button.displayName = "HoverablePopover.Button";
/* harmony default export */ const Button_Button = (Button);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/navigation/HoverablePopover/components/Overlay/Overlay.tsx





var Overlay = function(param) {
    var className = param.className, withDefaultStyle = param.withDefaultStyle;
    var hoverClosePopoverPanel = useHoverablePopoverContext().hoverClosePopoverPanel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J.Overlay, {
        className: (0,clsx/* default */.Z)(className, withDefaultStyle && "inset-0 bg-black fixed -z-1 opacity-50"),
        onMouseEnter: hoverClosePopoverPanel
    });
};
/* harmony default export */ const Overlay_Overlay = (Overlay);

;// CONCATENATED MODULE: ./src/components/navigation/HoverablePopover/HoverablePopover.tsx







var HoverablePopover = function(props) {
    var children = props.children, className = props.className, groupOpenedPopoverCountRef = props.groupOpenedPopoverCountRef;
    var buttonRef = (0,react.useRef)(null);
    var timeoutRef = (0,react.useRef)(null);
    var openStateRef = (0,react.useRef)(false);
    var closeFnRef = (0,react.useRef)(null);
    // we should restrict closePopoverPanel on mouse event if flyout was opened by keyboard
    var areMouseCloseEventsEnabledRef = (0,react.useRef)(false);
    var openPopoverPanel = function() {
        clearTimeout(timeoutRef.current);
        // we should check if it already open
        if (!openStateRef.current) {
            // if we have open popover from another NavRootItem we should open this one immediately
            if ((groupOpenedPopoverCountRef === null || groupOpenedPopoverCountRef === void 0 ? void 0 : groupOpenedPopoverCountRef.current) > 0) {
                var _buttonRef_current;
                (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.click();
            } else {
                timeoutRef.current = setTimeout(function() {
                    var _buttonRef_current;
                    (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.click();
                }, 250);
            }
            if (groupOpenedPopoverCountRef) {
                groupOpenedPopoverCountRef.current += 1;
            }
        }
    };
    var hoverClosePopoverPanel = (0,react.useCallback)(function(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (!areMouseCloseEventsEnabledRef.current) {
            return;
        }
        clearTimeout(timeoutRef.current);
        // close immediately if the user hovers another item
        if ((groupOpenedPopoverCountRef === null || groupOpenedPopoverCountRef === void 0 ? void 0 : groupOpenedPopoverCountRef.current) > 1) {
            if (openStateRef.current) {
                var _closeFnRef_current, // @ts-ignore
                _document_activeElement;
                (_closeFnRef_current = closeFnRef.current) === null || _closeFnRef_current === void 0 ? void 0 : _closeFnRef_current.call(closeFnRef);
                (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
                groupOpenedPopoverCountRef.current -= 1;
            }
        } else {
            timeoutRef.current = setTimeout(function() {
                if (openStateRef.current) {
                    var _closeFnRef_current, // @ts-ignore
                    _document_activeElement;
                    (_closeFnRef_current = closeFnRef.current) === null || _closeFnRef_current === void 0 ? void 0 : _closeFnRef_current.call(closeFnRef);
                    (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
                }
                if ((groupOpenedPopoverCountRef === null || groupOpenedPopoverCountRef === void 0 ? void 0 : groupOpenedPopoverCountRef.current) > 0) {
                    groupOpenedPopoverCountRef.current -= 1;
                }
            }, 150);
        }
    }, [
        groupOpenedPopoverCountRef
    ]);
    // if use has opened flyout by keyboard but switched to mouse we restore mouseLeave events
    var handleMove = function() {
        areMouseCloseEventsEnabledRef.current = true;
    };
    var hoverablePopoverContextValue = (0,react.useMemo)(function() {
        return {
            buttonRef: buttonRef,
            hoverClosePopoverPanel: hoverClosePopoverPanel
        };
    }, [
        hoverClosePopoverPanel
    ]);
    (0,react.useEffect)(function() {
        // block mouseLeave close event in case of pointer is out of Item area but it's opened via keyboard
        var handleKeyPress = function() {
            areMouseCloseEventsEnabledRef.current = false;
        };
        // we restrict close action by click on the button
        // to avoid unexpected behavior when menu opens via hover and user click in the same moment so menu blinks (opened and immediately closed)
        var preventCloseOnClick = function(event) {
            clearTimeout(timeoutRef.current);
            if (event.detail > 0 && openStateRef.current) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        // capture flag is required
        buttonRef.current.addEventListener("click", preventCloseOnClick, true);
        document.addEventListener("keydown", handleKeyPress);
        return function() {
            clearTimeout(timeoutRef.current);
            document.removeEventListener("keydown", handleKeyPress);
            closeFnRef.current = null;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopoverContext.Provider, {
        value: hoverablePopoverContextValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
            as: "div",
            className: className,
            onMouseEnter: openPopoverPanel,
            onMouseMove: handleMove,
            onMouseLeave: hoverClosePopoverPanel,
            children: function(param) {
                var open = param.open, close = param.close;
                openStateRef.current = open;
                closeFnRef.current = close;
                return typeof children === "function" ? children({
                    open: open,
                    close: close
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "children"
                });
            }
        })
    });
};
HoverablePopover.Button = Button_Button;
HoverablePopover.Overlay = Overlay_Overlay;
HoverablePopover.Panel = popover/* Popover */.J.Panel;
HoverablePopover.Group = popover/* Popover */.J.Group;
HoverablePopover.displayName = "HoverablePopover";
/* harmony default export */ const HoverablePopover_HoverablePopover = (HoverablePopover);


/***/ }),

/***/ 73358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14729);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17696);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var Href = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, href = props.href, to = props.to, toTab = props.toTab, mailto = props.mailto, message = props.message, block = props.block, inlineBlock = props.inlineBlock, disabled = props.disabled, rest = _object_without_properties(props, [
        "children",
        "className",
        "href",
        "to",
        "toTab",
        "mailto",
        "message",
        "block",
        "inlineBlock",
        "disabled"
    ]);
    var linkClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, {
        block: block,
        "inline-block": inlineBlock,
        "pointer-events-none": disabled
    });
    var content = message ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        value: message
    }) : children;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _object_spread_props(_object_spread({
            className: linkClassName,
            href: href,
            rel: "noopener noreferrer",
            ref: ref
        }, rest), {
            children: content
        }));
    }
    if (to) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(router__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _object_spread_props(_object_spread({
            className: linkClassName,
            to: to,
            ref: ref
        }, rest), {
            children: content
        }));
    }
    if (toTab) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _object_spread_props(_object_spread({
            className: linkClassName,
            href: toTab,
            target: "_blank",
            rel: "noopener noreferrer",
            ref: ref
        }, rest), {
            children: content
        }));
    }
    if (mailto) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _object_spread_props(_object_spread({
            className: linkClassName,
            href: "mailto:".concat(mailto),
            ref: ref
        }, rest), {
            children: content || mailto
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _object_spread_props(_object_spread({
        className: linkClassName,
        ref: ref
    }, rest), {
        children: content
    }));
});
Href.displayName = "Href";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Href);


/***/ }),

/***/ 91515:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Pagination_Pagination)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__(21402);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-paginate@8.2.0_react@18.2.0/node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(8606);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/components/navigation/Pagination/Pagination.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Pagination_module = ({"pagination":"fTdWZ6","page":"eYCCcM","active":"ZImUzz","pageLink":"hw89uO","arrowLink":"zLbSmq"});
;// CONCATENATED MODULE: ./src/components/navigation/Pagination/messages.ts
/* harmony default export */ const messages = ({
    prev: {
        long: {
            en: "Prev page"
        },
        short: {
            en: "Prev"
        }
    },
    next: {
        long: {
            en: "Next page"
        },
        short: {
            en: "Next"
        }
    }
});

;// CONCATENATED MODULE: ./src/components/navigation/Pagination/Pagination.tsx
/*

  ATTN If you need to load data based on active page then you need to use query params!

  Example:

  <Products>
  <Pagination />

  const Products = () => {
    const [ { page } ] = useSearchParams()

    // load data based on "page" value, on paginate its value will be changed and Products component will be re-rendered
  }

 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}









var Pagination = function(props) {
    var className = props.className, pageCount = props.pageCount, _props_queryKey = props.queryKey, queryKey = _props_queryKey === void 0 ? "page" : _props_queryKey, _props_scroll = props.scroll, scroll = _props_scroll === void 0 ? true : _props_scroll, onChange = props.onChange;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useSearchParams = _sliced_to_array((0,contexts/* useSearchParams */.lr)(), 2), searchParams = _useSearchParams[0], setSearchParams = _useSearchParams[1];
    var page = parseInt(searchParams[queryKey]) || 0;
    var handleClick = (0,react.useCallback)(function(param) {
        var pageNum = param.selected;
        setSearchParams(function(prev) {
            return _object_spread_props(_object_spread({}, prev), _define_property({}, queryKey, pageNum));
        }, false, scroll);
        if (typeof onChange === "function") {
            onChange(pageNum);
        }
    }, [
        queryKey,
        scroll,
        onChange,
        setSearchParams
    ]);
    var previousLabelNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "other/long-arrow-left",
                color: "gold-50"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: isMobile ? messages.prev["short"] : messages.prev["long"],
                style: "t5",
                color: "gold-50"
            })
        ]
    });
    var breakLabelNode = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: "..."
    });
    var nextLabelNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: isMobile ? messages.next["short"] : messages.next["long"],
                style: "t5",
                color: "gold-50"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "other/long-arrow-right",
                color: "gold-50"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
            forcePage: page,
            containerClassName: Pagination_module.pagination,
            pageClassName: Pagination_module.page,
            pageLinkClassName: Pagination_module.pageLink,
            previousClassName: Pagination_module.page,
            previousLinkClassName: Pagination_module.arrowLink,
            nextClassName: Pagination_module.page,
            nextLinkClassName: Pagination_module.arrowLink,
            breakClassName: Pagination_module.page,
            breakLinkClassName: Pagination_module.pageLink,
            activeClassName: Pagination_module.active,
            pageCount: pageCount,
            pageRangeDisplayed: isMobile ? 1 : 4,
            marginPagesDisplayed: isMobile ? 1 : 2,
            previousLabel: previousLabelNode,
            nextLabel: nextLabelNode,
            breakLabel: breakLabelNode,
            onPageChange: handleClick
        })
    });
};
/* harmony default export */ const Pagination_Pagination = (/*#__PURE__*/react.memo(Pagination));


/***/ }),

/***/ 22958:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Tabs_Tabs)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(40963);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(65021);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
;// CONCATENATED MODULE: ./src/components/navigation/Tabs/util/useQueryTabs.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}




// Sync tabs state with search params
var useQueryTabs = function(props) {
    var _props_availableTabIds = props.availableTabIds, availableTabIds = _props_availableTabIds === void 0 ? [] : _props_availableTabIds, defaultActiveTab = props.defaultActiveTab, withScroll = props.withScroll;
    var _useSearchParams = _sliced_to_array((0,contexts/* useSearchParams */.lr)(), 2), searchParams = _useSearchParams[0], setSearchParams = _useSearchParams[1];
    // tab from the search params
    var tab = searchParams.tab;
    var activeTab = (0,react.useMemo)(function() {
        if (availableTabIds.includes(tab)) {
            return tab;
        }
        if (defaultActiveTab) {
            return defaultActiveTab;
        }
        return availableTabIds.length ? availableTabIds[0] : "";
    }, [
        tab,
        availableTabIds,
        defaultActiveTab
    ]);
    var setActiveTab = (0,react.useCallback)(function(id) {
        setSearchParams(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                tab: id
            });
        }, true, withScroll);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return [
        activeTab,
        setActiveTab
    ];
};
/* harmony default export */ const util_useQueryTabs = (useQueryTabs);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(26368);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(96669);
;// CONCATENATED MODULE: ./src/components/navigation/Tabs/util/useTabsKeyboard.ts








var useTabsKeyboard = function(param) {
    var activeTab = param.activeTab, availableTabIds = param.availableTabIds, setActiveTab = param.setActiveTab;
    var tabListRef = (0,react.useRef)();
    var activeTabRef = (0,react.useRef)(activeTab);
    var setActiveTabRef = (0,react.useRef)(setActiveTab);
    activeTabRef.current = activeTab;
    (0,react.useEffect)(function() {
        var _tabListRef_current;
        var tabs = Array.from(((_tabListRef_current = tabListRef.current) === null || _tabListRef_current === void 0 ? void 0 : _tabListRef_current.children) || []);
        if (tabs.length) {
            var handleKeyDown = function(event) {
                var isActiveTab = event.target.tabIndex === 0;
                var isTabSwitch = isActiveTab && [
                    37,
                    39,
                    35,
                    36
                ].includes(event.keyCode);
                if (isTabSwitch) {
                    var _tabListRef_current, _setActiveTabRef_current, _nextTabElement_focus;
                    var tabs = Array.from(((_tabListRef_current = tabListRef.current) === null || _tabListRef_current === void 0 ? void 0 : _tabListRef_current.children) || []);
                    var lastIndex = availableTabIds.length - 1;
                    var currentIndex = availableTabIds.indexOf(activeTabRef.current);
                    var isLast = currentIndex === lastIndex;
                    var isFirst = currentIndex === 0;
                    var nextIndex = {
                        37: isFirst ? lastIndex : currentIndex - 1,
                        39: isLast ? 0 : currentIndex + 1,
                        35: lastIndex,
                        36: 0
                    }[event.keyCode];
                    (_setActiveTabRef_current = setActiveTabRef.current) === null || _setActiveTabRef_current === void 0 ? void 0 : _setActiveTabRef_current.call(setActiveTabRef, availableTabIds[nextIndex]);
                    var nextTabElement = tabs[nextIndex];
                    (_nextTabElement_focus = nextTabElement.focus) === null || _nextTabElement_focus === void 0 ? void 0 : _nextTabElement_focus.call(nextTabElement);
                }
            };
            tabs.forEach(function(tab) {
                return tab.addEventListener("keydown", handleKeyDown);
            });
            return function() {
                tabs.forEach(function(tab) {
                    return tab.removeEventListener("keydown", handleKeyDown);
                });
            };
        }
    }, [
        availableTabIds
    ]);
    return tabListRef;
};
/* harmony default export */ const util_useTabsKeyboard = (useTabsKeyboard);

// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/components/navigation/Tabs/Tab/Tab.tsx
function Tab_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var activeColorToClassName = {
    "gold-50": "border-gold-50",
    white: "border-white"
};
var Tab = function(props) {
    var id = props.id, tagId = props.tagId, title = props.title, titleContent = props.titleContent, isActive = props.isActive, _props_activeColor = props.activeColor, activeColor = _props_activeColor === void 0 ? "gold-50" : _props_activeColor, withMargin = props.withMargin, onClick = props.onClick;
    var rootClassName = (0,clsx/* default */.Z)("cursor-pointer whitespace-nowrap border-0 border-b-2 border-solid px-0 py-[9rem] first:ml-0", Tab_define_property({
        "ml-32": withMargin,
        "cursor-default": isActive,
        "border-transparent": !isActive
    }, activeColorToClassName[activeColor], isActive));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: rootClassName,
        id: tagId,
        message: title,
        style: "h8",
        color: isActive ? activeColor : "black",
        tag: "button",
        role: "tab",
        tabIndex: isActive ? 0 : -1,
        "aria-controls": "".concat(tagId, "-panel"),
        "aria-selected": isActive,
        "data-testid": "".concat(id, "Tab"),
        onClick: function() {
            return onClick(id);
        },
        html: true,
        children: titleContent
    });
};
/* harmony default export */ const Tab_Tab = (/*#__PURE__*/react.memo(Tab));

;// CONCATENATED MODULE: ./src/components/navigation/Tabs/Content/Content.tsx


var Content = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.children
    });
};
/* harmony default export */ const Content_Content = (Content);

;// CONCATENATED MODULE: ./src/components/navigation/Tabs/Tabs.tsx
function Tabs_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Tabs_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Tabs_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Tabs_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Tabs_sliced_to_array(arr, i) {
    return Tabs_array_with_holes(arr) || Tabs_iterable_to_array_limit(arr, i) || Tabs_unsupported_iterable_to_array(arr, i) || Tabs_non_iterable_rest();
}
function Tabs_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Tabs_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tabs_array_like_to_array(o, minLen);
}















var Tabs_activeColorToClassName = {
    "gold-50": "border-gold-50",
    white: "border-white"
};
var Tabs = function(props) {
    var children = props.children, className = props.className, _props_tabsClassName = props.tabsClassName, tabsClassName = _props_tabsClassName === void 0 ? "min-w-full" : _props_tabsClassName, _props_activeColor = props.activeColor, activeColor = _props_activeColor === void 0 ? "gold-50" : _props_activeColor, _props_justify = props.justify, justify = _props_justify === void 0 ? "justify-start" : _props_justify, controllableActiveTab = props.activeTab, defaultActiveTab = props.defaultActiveTab, _props_withWidthContainer = props.withWidthContainer, withWidthContainer = _props_withWidthContainer === void 0 ? false : _props_withWidthContainer, _props_withQuery = props.withQuery, withQuery = _props_withQuery === void 0 ? false : _props_withQuery, _props_withScroll = props.withScroll, withScroll = _props_withScroll === void 0 ? true : _props_withScroll, onChange = props.onChange;
    var tabsId = (0,useUniqueId/* default */.Z)("tabs");
    var _useMemo = Tabs_sliced_to_array((0,react.useMemo)(function() {
        var tabContentById = {};
        var availableTabIds = [];
        react.Children.toArray(children).forEach(function(child) {
            var _child_props;
            if (!/*#__PURE__*/ react.isValidElement(child)) {
                return;
            }
            var id = child === null || child === void 0 ? void 0 : (_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.id;
            if (id) {
                availableTabIds.push(id);
                tabContentById[id] = child;
            }
        });
        return [
            tabContentById,
            availableTabIds
        ];
    }, [
        children
    ]), 2), tabContentById = _useMemo[0], availableTabIds = _useMemo[1];
    var state = (0,react.useState)(defaultActiveTab || availableTabIds[0]);
    var queryState = util_useQueryTabs({
        availableTabIds: availableTabIds,
        defaultActiveTab: defaultActiveTab,
        withScroll: withScroll
    });
    var activeTab;
    var setActiveTab;
    if (controllableActiveTab && typeof onChange === "function") {
        activeTab = controllableActiveTab;
        setActiveTab = onChange;
    } else {
        var ref;
        ref = Tabs_sliced_to_array(withQuery ? queryState : state, 2), activeTab = ref[0], setActiveTab = ref[1], ref;
    }
    var tabsRef = util_useTabsKeyboard({
        availableTabIds: availableTabIds,
        activeTab: activeTab,
        setActiveTab: setActiveTab
    });
    var activeTabRef = (0,react.useRef)();
    activeTabRef.current = activeTab;
    var handleClick = (0,react.useCallback)(function(id) {
        if (activeTabRef.current === id) {
            return;
        }
        setActiveTab(id);
        if (typeof onChange === "function") {
            onChange(id);
        }
    }, [
        setActiveTab,
        onChange
    ]);
    var tabs = /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
        className: "no-scrollbar overflow-x-auto",
        ignore: !withWidthContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)("inline-flex border-b border-solid", tabsClassName, Tabs_activeColorToClassName[activeColor], justify),
            ref: tabsRef,
            role: "tablist",
            children: react.Children.map(children, function(child) {
                if (!/*#__PURE__*/ (0,react.isValidElement)(child)) {
                    return child;
                }
                var _child_props = child.props, id = _child_props.id, title = _child_props.title, titleContent = _child_props.titleContent;
                var isActive = id === activeTab;
                var withMargin = justify === "justify-start" || justify === "justify-center";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                    id: id,
                    tagId: "".concat(tabsId, "-").concat(id),
                    title: title,
                    titleContent: titleContent,
                    isActive: isActive,
                    activeColor: activeColor,
                    withMargin: withMargin,
                    onClick: handleClick
                }, id);
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        id: tabsId,
        children: [
            tabs,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "".concat(tabsId, "-").concat(activeTab, "-panel"),
                role: "tabpanel",
                tabIndex: 0,
                "aria-labelledby": "".concat(tabsId, "-").concat(activeTab),
                children: tabContentById[activeTab]
            })
        ]
    });
};
Tabs.Content = Content_Content;
/* harmony default export */ const Tabs_Tabs = (Tabs);


/***/ })

}]);